import { Component, OnInit, TemplateRef, ViewChild, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UsersService, ErrorService, TreeService, LanguageService } from '@shared/services';
import { Subject, Subscription } from 'rxjs';
import { takeUntil, first } from 'rxjs/operators';
import { environment } from '@environment/environment';
import { FormsModule } from '@angular/forms';
import { Localization } from '@shared/_models/localization';

@Component({
  selector: 'app-translation-popup',
  templateUrl: './translation-popup.component.html',
  styleUrls: ['./translation-popup.component.scss']
})
export class TranslationPopupComponent implements OnInit {

  constructor(private modalService: BsModalService,
      private _treeService: TreeService,
     private _service: LanguageService,
     private _userService :  UsersService,
       private _errorService: ErrorService,
        private _usersService: UsersService,) { }

     getList() {
            
            this._userService
                .GetCultures()
                .pipe(takeUntil(this._unsubscribeAll$), first())
                .subscribe((result) => {
                    
              this.cultureList = result.data.map(culture => ({
        ...culture,
        text: ''
      }));
               console.log("culture list kerollos ", this.cultureList);
                    
                    // After loading cultures, load the existing translations
                    this.loadExistingTranslations();
                });
        }

    loadExistingTranslations() {
        if (this.CanAdd == true && this.masterItemId) {
            this._userService
                .getListOfLocalizations(this.masterItemId, this.masterColumnName)
                .pipe(takeUntil(this._unsubscribeAll$), first())
                .subscribe((result) => {
                    
                    if (result.data && this.cultureList) {

                        result.data.forEach((localization: any) => {
                            const matchingCulture = this.cultureList.find((culture: any) => 
                                culture.cultureId === localization.cultureId
                            );
                            
                            if (matchingCulture) {
                                matchingCulture.text = localization.masterText;
                                // Also store the localizationId for potential updates
                                matchingCulture.localizationId = localization.localizationId;
                            }
                        });
                        
                        console.log("Updated culture list with existing translations: ", this.cultureList);
                    }
                    
                    // Now open the modal after data is loaded
                    this.showModal();
                });
        } else {
            // If no existing translations to load, just show the modal
            this.showModal();
        }
    }

    showModal() {
        const modalClass = this.isCenter 
            ? 'modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated'
            : 'modal-lg modal-primary ModelPopUpLayout1 commenModel animated customHeight';
            
        const configs = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: modalClass,
            animated: false
        };
        
        this.modalRefTranslation = this.modalService.show(this.TranslationModal, configs);
        console.log("translationText", this.translationText);
    }
  ngOnInit(): void {
//this.getList();
  }
  cultureList: any;
    @ViewChild('translationForm', { static: true }) TranslationModal: TemplateRef<any>;
    private _unsubscribeAll$ = new Subject<void>();
        @Output('ispopupClosed')
        ispopupClosed: EventEmitter<any> = new EventEmitter<any>();

        @Input() translationText: string;
        @Input() isCenter: boolean = false;

  modalRefTranslation: BsModalRef | null;
   @Output() modalStateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
openModal(): void {
  //debugger
    if(this.translationText == null) {
        this.newMessage(226, '');
        // Emit false to parent since modal is not opening
        this.modalStateChanged.emit(false);
        return;
    }
    
    // Emit true to parent since modal is opening
    this.modalStateChanged.emit(true);
    
    // Start the loading sequence: first load cultures, then translations, then show modal
    this.getList();
}

closeTranslationModal() {
    this.modalStateChanged.emit(false); // Also emit false when closing
    this.ispopupClosed.emit({saved: false}); // Changed to emit object with saved flag
    this.modalRefTranslation.hide();
}
      clearText(index: number) {
  if (this.cultureList && this.cultureList[index]) {
    this.cultureList[index].text = '';
    console.log(`Cleared text for culture: ${this.cultureList[index].cultureName}`);
  }
}

newMessage(id, action) {
        this._errorService.changeMessage({ id: id, action: action });
    }
canGo = true;
localizationLst: any;
localization = new Localization();
 @Input('CanAdd')
    CanAdd = true;
        DeletemasterItemId: string;

           @Output('CultureObj')
    CultureObj: EventEmitter<any> = new EventEmitter<any>();
    @Input('masterColumnName')
    masterColumnName;
      @Input('masterItemId')
    masterItemId;
    @Input('originalTableName')
    originalTableName;
     @Input('disable')
    disable = true;
        @Input('OriginalValue')
    OriginalValue;
        afterSaveSub: Subscription;
    
saveAddEdit() {
    //debugger
    this.localizationLst = [];
    
    // Create a list similar to LocalizationsList from the first component
    const localizationsToSave = [];
    
    // Process ALL cultures (both with text and without text for deletions)
    this.cultureList.forEach((culture) => {
        // If culture has localizationId (exists in database) but text is empty, mark for deletion
        if (culture.localizationId && (!culture.text || culture.text.trim() === '')) {
            const deletionItem = {
                masterItemId: this.masterItemId,
                cultureId: culture.cultureId,
                masterText: '', // Empty text indicates deletion
                createUser: '',
                modifyUser: '',
                createStamp: 0,
                modifyStamp: '',
                masterColumnName: this.masterColumnName,
                originalTableName: this.originalTableName,
                cultureName: culture.cultureName || 0,
                languageId: culture.languageId || 0,
                languageName: culture.languageName || 0,
                direction: culture.direction || 0,
                localizationId: culture.localizationId,
                isDelete: true // Flag to indicate this should be deleted
            };
            localizationsToSave.push(deletionItem);
        }
        // If culture has text, include it for save/update
        else if (culture.text && culture.text.trim() !== '') {
            const localizationItem = {
                masterItemId: this.masterItemId,
                cultureId: culture.cultureId,
                masterText: culture.text,
                createUser: '',
                modifyUser: '',
                createStamp: 0,
                modifyStamp: '',
                masterColumnName: this.masterColumnName,
                originalTableName: this.originalTableName,
                cultureName: culture.cultureName || 0,
                languageId: culture.languageId || 0,
                languageName: culture.languageName || 0,
                direction: culture.direction || 0,
                localizationId: culture.localizationId || undefined,
                isDelete: false
            };
            localizationsToSave.push(localizationItem);
        }
    });

    // Now process the localizationsToSave array (same logic as first component)
    localizationsToSave.forEach((key) => {
        var exist = this.localizationLst.find((l) => l.cultureId == key.cultureId);
        if (exist) {
            this.canGo = false;
            this.newMessage(162, '');
        } else {
            this.canGo = true;
        }

        this.localization = new Localization();
        this.localization.masterColumnName = key.masterColumnName;
        this.localization.cultureId = key.cultureId;
        this.localization.masterItemId = key.masterItemId;
        this.localization.masterText = key.masterText;
        this.localization.localizationId = key.localizationId;
        this.localization.originalTableName = this.originalTableName;
        
        // Add the deletion flag if it exists (using any to bypass type checking)
        if (key.isDelete) {
            (this.localization as any).isDelete = true;
        }
        
        this.localizationLst.push(this.localization);
    });

    if (!this.canGo) return;

    if (this.CanAdd == true) {
        // Separate items for deletion from items for save/update
        const itemsToDelete = this.localizationLst.filter(item => (item as any).isDelete);
        const itemsToSave = this.localizationLst.filter(item => !(item as any).isDelete);
        
        // Handle deletions first
        if (itemsToDelete.length > 0) {
            // Extract only the localizationIds for deletion
            const localizationIdsToDelete = itemsToDelete
                .filter(item => item.localizationId)
                .map(item => item.localizationId);
            
            console.log('Localization IDs to delete:', localizationIdsToDelete);
            
            if (localizationIdsToDelete.length > 0) {
                this._usersService
                    .deleteLocalizationLst(localizationIdsToDelete)
                    .pipe(takeUntil(this._unsubscribeAll$), first())
                    .subscribe((deleteResult) => {
                        console.log('Delete result:', deleteResult);
                        // After deletions, handle saves/updates
                        this.handleSaveUpdates(itemsToSave);
                    }, (error) => {
                        console.error('Delete error:', error);
                        // Still try to save updates even if deletion fails
                        this.handleSaveUpdates(itemsToSave);
                    });
            } else {
                // No valid IDs to delete, just handle saves/updates
                this.handleSaveUpdates(itemsToSave);
            }
        } else {
            // No deletions needed, just handle saves/updates
            this.handleSaveUpdates(itemsToSave);
        }
    } else {
        this.CultureObj.emit(this.localizationLst);
        this.newMessage(112, '');
        this.modalStateChanged.emit(false);
        this.ispopupClosed.emit({saved: true});
        this.modalRefTranslation.hide();
    }
}

handleSaveUpdates(itemsToSave: any[]) {
    if (itemsToSave.length > 0 || this.DeletemasterItemId != null) {
        if (itemsToSave.length == 0) {
            if (this.DeletemasterItemId != null) {
                this.localization = new Localization();
                this.localization.masterItemId = this.DeletemasterItemId;
                itemsToSave.push(this.localization);
            }
        }

        // Clean up items to save - remove any extra properties
        const cleanedItemsToSave = itemsToSave.map(item => {
            const cleanItem = { ...item };
            delete (cleanItem as any).isDelete; // Remove the isDelete property
            return cleanItem;
        });

        console.log('Cleaned items to save:', cleanedItemsToSave);
        this.afterSaveSub = this._usersService
            .addLocalizationLst(cleanedItemsToSave)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                console.log('Save result:', result);
                if (result.isSuccess) {
                    this.newMessage(112, '');
                    this.modalStateChanged.emit(false);
                    this.ispopupClosed.emit({saved: true}); // Emit object with saved flag
                    this.modalRefTranslation.hide();
                } else {
                    // Handle error case
                }
            });
    } else {
        // No items to save, just close the modal
        this.newMessage(112, '');
        this.modalStateChanged.emit(false);
        this.ispopupClosed.emit({saved: true}); // Still consider it saved since there were no changes
        this.modalRefTranslation.hide();
    }
}
}
